import React, { useMemo } from 'react';
import { compose } from 'recompose';
import styled from 'styled-components';
import pageWithProps from 'shared/hoc/pageWithProps';
import useIsMobile from 'shared/hooks/useIsMobile';
import { upToMedia } from 'shared/style/media';
import { getDocumentByType } from 'shared/utils/documents';
import { Hero, CallToAction, ImgTitleInfoCta, TitleAndInfoRepeatable } from 'shared/components';

const ImgTitleInfoCtaWrp = styled(ImgTitleInfoCta)`
  ${upToMedia.tablet`
  `}
`;

function Enterprise({
  hero_image,
  headline,
  sub_heading,
  cta_primary_button_text,
  cta_primary_button_link,
  cta_secondary_button_text,
  cta_secondary_button_link,
  images_and_info,
  section_title,
  title_and_info,
  bottom_cta_headline,
  bottom_cta_sub_heading,
  bottom_cta_primary_button_text,
  bottom_cta_primary_button_link,
  bottom_cta_secondary_button_text,
  bottom_cta_secondary_button_link,

  utm_source,
  utm_medium,
}) {
  const isMobile = useIsMobile();

  return (
    <>
      <Hero
        hero_image={hero_image}
        heading={headline}
        subheading={sub_heading}
        cta_primary_text={cta_primary_button_text}
        cta_primary_link={cta_primary_button_link}
        cta_secondary_text={cta_secondary_button_text}
        cta_secondary_link={cta_secondary_button_link}
        utm_source={utm_source}
        utm_medium={utm_medium}
        cta_primary_button_field_name="cta_primary_button_link"
        cta_secondary_button_field_name="cta_secondary_button_link"
      />

      <ImgTitleInfoCtaWrp
        {...{
          items: images_and_info,
          direction: isMobile ? 'Vertical' : 'Horizontal',
          mobileBigImages: true,
        }}
      />

      {/* <ImgTitleInfoCtaWrp items={images_and_info} direction="Horizontal" /> */}

      <TitleAndInfoRepeatable
        section_title={section_title}
        wrap_mode="Wrap"
        items={title_and_info}
      />

      <CallToAction
        headline={bottom_cta_headline}
        sub_heading={bottom_cta_sub_heading}
        cta_primary_button_text={bottom_cta_primary_button_text}
        cta_primary_button_link={bottom_cta_primary_button_link}
        cta_secondary_button_text={bottom_cta_secondary_button_text}
        cta_secondary_button_link={bottom_cta_secondary_button_link}
        background_color="#fff"
        utm_source={utm_source}
        utm_medium={utm_medium}
        cta_primary_button_field_name="bottom_cta_primary_button_link"
        cta_secondary_button_field_name="bottom_cta_secondary_button_link"
      />
    </>
  );
}

const enhance = compose(
  pageWithProps(async ({ lang, ref }) => ({
    ...(await getDocumentByType('enterprise', lang, ref)),
  })),
);

export default enhance(Enterprise);
